import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    data: {
      seo: {
        title: 'Portfolio',
        description: 'Portfolio of Balkishan Dhaker, a fullstack developer specializing in Angular, Ionic, and cross-platform app development.',
        keywords: 'Balkishan Dhaker portfolio, Angular developer portfolio, Ionic developer portfolio, fullstack developer India'
      }
    },
    loadChildren: () => import('./modules/creator/creator.module').then( m => m.CreatorPageModule)
  },
  {
    path: 'padhiyega',
    data: {
      seo: {
        title: 'Padhiyega Project',
        description: 'Padhiyega project showcase by Balkishan Dhaker.',
        keywords: 'Padhiyega, Balkishan Dhaker project'
      }
    },
    loadChildren: () => import('./modules/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'creator',
    data: {
      seo: {
        title: 'Creator Profile',
        description: 'Explore Balkishan Dhaker’s creator profile, experience, and software development work.',
        keywords: 'Balkishan Dhaker profile, Angular Ionic developer, software developer profile'
      }
    },
    loadChildren: () => import('./modules/creator/creator.module').then( m => m.CreatorPageModule)
  },
  {
    path: 'calendar',
    data: {
      seo: {
        title: 'Calendar App',
        description: 'Calendar app example built by Balkishan Dhaker.',
        robots: 'noindex, follow'
      }
    },
    loadChildren: () => import('./pages/apps/calendar/calendar.module').then( m => m.CalendarPageModule)
  },
  {
    path: 'examples',
    data: {
      seo: {
        title: 'Examples',
        description: 'UI and product examples by Balkishan Dhaker.',
        robots: 'noindex, follow'
      }
    },
    loadChildren: () => import('./modules/examples/examples.module').then( m => m.ExamplesPageModule)
  },
  {
    path: 'ui',
    data: {
      seo: {
        title: 'UI Samples',
        description: 'UI exploration work by Balkishan Dhaker.',
        robots: 'noindex, follow'
      }
    },
    loadChildren: () => import('./modules/ui/ui.module').then( m => m.UiPageModule)
  },
  {
    path: 'gyp-realestimate',
    data: {
      seo: {
        title: 'GYP RealEstimate',
        description: 'GYP RealEstimate project showcase by Balkishan Dhaker.'
      }
    },
    loadChildren: () => import('./pages/apps/gyp-realestimate/gyp-realestimate.module').then( m => m.GypRealestimatePageModule)
  },


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      initialNavigation: 'enabledBlocking'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
